module.exports = "/_next/static/images/420486aeb822eef8f5e34826202f2f60-mockup-transfer-fgts@0.5x.jpg";